<h2>Ограничения</h2>

<div class="container restrictions-container">
  <ng-container *ngIf="(user$ | async) as user">

    <!-- Журнал блокировок открывается отдельной модалкой (с серверной пагинацией) -->
    <div class="lock-history-bar">
      <button mat-stroked-button class="btn btn-sm" (click)="openHistory()">История блокировок</button>
    </div>

    <mat-divider class="divider"></mat-divider>

    <div class="toggles-container">

      <!-- Все типы блокировок одним списком. Состояние/кто/источник/время — из новой таблицы user_lock. -->
      <div class="lock-row"
           *ngFor="let row of lockRows"
           [class.lock-row--active]="row.isActive">
        <div class="lock-row__main">
          <mat-slide-toggle class="toggle"
                            labelPosition="before"
                            [checked]="row.isActive"
                            (change)="toggleLock(row, $event)">
            <span class="description">{{ row.label }}</span>
          </mat-slide-toggle>
          <mat-icon class="lock-help"
                    [matTooltip]="row.description"
                    matTooltipPosition="above">help_outline</mat-icon>
        </div>

        <!-- Иконки строки лока: у каждой matTooltip-пояснение, что значит значение рядом. -->
        <div class="lock-row__meta" *ngIf="row.isActive && row.entry as entry">
          <span class="lock-meta-item">
            <mat-icon class="lock-meta-icon" matTooltip="Кто поставил блокировку" matTooltipPosition="above">person</mat-icon>
            <ng-container *ngTemplateOutlet="actorCell; context: { actorType: entry.actorType, actorId: entry.actorId }"></ng-container>
          </span>
          <span class="lock-meta-item">
            <mat-icon class="lock-meta-icon" matTooltip="Тип инициатора (админ / система / авто / сам пользователь)" matTooltipPosition="above">badge</mat-icon>
            {{ actorTypeLabel(entry.actorType) }}
          </span>
          <span class="lock-meta-item" *ngIf="entry.source">
            <mat-icon class="lock-meta-icon" matTooltip="Источник — откуда прилетела блокировка" matTooltipPosition="above">input</mat-icon>
            {{ entry.source }}
          </span>
          <span class="lock-meta-item">
            <mat-icon class="lock-meta-icon" matTooltip="Когда блокировка поставлена" matTooltipPosition="above">schedule</mat-icon>
            {{ entry.createdAt | date: 'dd.MM.yy HH:mm' }}
          </span>
          <!-- Срок: когда блокировка автоматически снимется (expiresAt); нет срока — бессрочно -->
          <span class="lock-meta-item">
            <mat-icon class="lock-meta-icon" matTooltip="Срок — когда блокировка автоматически снимется" matTooltipPosition="above">timer</mat-icon>
            {{ entry.expiresAt ? ('снимется ' + (entry.expiresAt | date: 'dd.MM.yy HH:mm')) : 'бессрочно' }}
          </span>
          <span class="lock-meta-item" *ngIf="entry.reason">
            <mat-icon class="lock-meta-icon" matTooltip="Причина блокировки" matTooltipPosition="above">info</mat-icon>
            {{ entry.reason }}
          </span>
        </div>
      </div>

      <mat-divider class="divider"></mat-divider>

      <!-- Не блокировки: служебные тогглы пользователя -->
      <mat-slide-toggle class="toggle"
                        labelPosition="before"
                        [checked]="user.security.isTrader"
                        (change)="toggleTrader($event)">
        <span class="description">Трейдер</span>
      </mat-slide-toggle>

      <mat-slide-toggle class="toggle"
                        labelPosition="before"
                        [checked]="user.security.ignoreFraudLock"
                        (change)="toggleIgnoreFraud($event)">
        <span class="description">Игнор фрод-ошибок вывода (Server Error #1 / Fraud Detected)</span>
      </mat-slide-toggle>

      <div class="toggle-row">
        <mat-slide-toggle class="toggle"
                          labelPosition="before"
                          [checked]="user.security.promoMoreDeposit"
                          (change)="toggleSetPromoMoreDeposit($event)">
          <span class="description">С этим блоком промокод дает бонус при пополнении от f50</span>
        </mat-slide-toggle>
      </div>

      <div class="withdraw-limit-container">
        <div class="withdraw-limit">
          <span>Суточный лимит: </span>
          <span matTooltip="{{-1 * (user.security.storeWithdrawLimit || 0) | fastCoinsToDollar}}"
                matTooltipPosition="above">
            <b>{{ -1 * ((user.security.storeWithdrawLimit || 0) / 100) }}</b>
          </span>
        </div>
        <button mat-flat-button color="primary" class="btn btn-sm" (click)="setStoreWithdrawLimit()">Edit</button>
      </div>

      <mat-divider class="divider"></mat-divider>

      <ng-container *access="['main_owner']">
        <button class="btn btn-sm btn-alert reset-account" (click)="resetUserAccount(user.fastId)">Полный сброс аккаута</button>
        <button class="btn btn-sm"
                [disabled]="isRotatingProvablyFairSeed"
                (click)="rotateProvablyFairSeed(user.fastId)">
          {{ isRotatingProvablyFairSeed ? 'Смена seed...' : 'Сменить provably-fair seed' }}
        </button>
        <mat-divider class="divider"></mat-divider>
      </ng-container>

      <ng-container *ngIf="checkUserAccess$ | async as access">
        <ng-container *ngIf="!(access.success && access.hasRefund?.success)">
          <span>Возврат невозможен: <b [style.color]="'red'">{{ access.hasRefund?.error || access?.error }}</b></span>
          <mat-divider class="divider"></mat-divider>
        </ng-container>
      </ng-container>

      <b>Блокировки выводов v2 </b>
      <table border="1" cellspacing="0" cellpadding="8" style="width: 100%; border-collapse: collapse;">
        <thead>
        <tr>
          <th>Is Locked</th>
          <th>End At</th>
          <th>Available Payout</th>
          <th>Lock Reason</th>
          <th>Unlock Payment</th>
          <th>Admin ID</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ (user.security.userPayoutLock?.isLock && user.security.userPayoutLock) ? 'Yes' : 'No' }}</td>
          <td>{{ user.security.userPayoutLock?.endAt ? (user.security.userPayoutLock?.endAt | date: 'dd.MM.yy HH:mm') : '-' }}</td>
          <td>{{ ((user.security.userPayoutLock?.availablePayoutSum || 0) / 100) | currency : 'USD' }}</td>
          <td>{{ user.security.userPayoutLock?.lockReason }}</td>
          <td>{{ ((user.security.userPayoutLock?.unlockPaymentSum || 0) / 100) | currency : 'USD' }}</td>
          <td>{{ (user.security.userPayoutLock?.adminId | number) || '-' }}</td>
          <td>
            <button mat-flat-button color="primary" class="btn btn-sm" (click)="editPayoutLock(user)">Edit</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <mat-divider class="divider"></mat-divider>

    <button class="btn btn-sm" (click)="unlockBalance()">Разблокировать баланс</button>
  </ng-container>
</div>

<!-- Ячейка «кто поставил»: для админа ID кликабелен — переход на страницу юзера (как «Who» на /promo) -->
<ng-template #actorCell let-actorType="actorType" let-actorId="actorId">
  <ng-container *ngIf="actorType === 'admin' && actorId; else plainActor">
    Админ <a [routerLink]="['/user/', actorId]">#{{ actorId }}</a>
  </ng-container>
  <ng-template #plainActor>{{ formatActor(actorType, actorId) }}</ng-template>
</ng-template>
